<h1>PROCEEDINGS</h1>
<p>
	Each talk presented at De Cifris workshops will be published as follows:
</p>
<ul style="list-style-type: none">
	<li>
		A two-page mini-abstract will appear in the main Proceedings book, which will be an issue of our book
		series <b>De Cifris Koine</b>. The paper will also appear in other forms freely: since the mini-abstract
		is only two-page long, its publication in <b>Koine</b> will not affect the publication of the full paper
		in other venues.
	</li>
</ul>
<p>
	Remarks:
</p>
<ol type="A">
	<li>
		In any case, a two-page abstract <b>must</b> appear in <b>Koine</b>. Authors of accepted workshop talks
		are expected to send it to <a href="mailto:editorial@decifris.it">editorial&#64;decifris.it</a> not later
		than the 4-th of September.
	</li>

	<li>
		<b>Koine</b> is an Open Access publications, with <b>no fees</b> for authors, published by <b
			style="color:red;">De Cifris Press</b>, our own publishing house.
	</li>

	<li>
		<b>Koine</b> is a book series that will not be indexed by search engines, such as Scopus. Its books only
		have the goal to showcase the activities of the Italian community.
	</li>
</ol>
